const rankings = [
  {
    rank: 1,
    title: '顶流网红直播翻车名场面合集',
    tag: '网红爆料',
    heat: '🔥 128.6万',
    trend: 'up',
  },
  {
    rank: 2,
    title: '某知名艺人私下言论遭曝光',
    tag: '娱乐圈',
    heat: '🔥 96.3万',
    trend: 'up',
  },
  {
    rank: 3,
    title: '综艺录制现场嘉宾当场翻脸',
    tag: '现场实拍',
    heat: '🔥 85.7万',
    trend: 'up',
  },
  {
    rank: 4,
    title: '头部主播涉嫌虚假宣传维权',
    tag: '黑料深扒',
    heat: '🔥 73.2万',
    trend: 'new',
  },
  {
    rank: 5,
    title: '健身房私教骚扰学员监控外泄',
    tag: '爆料视频',
    heat: '🔥 62.8万',
    trend: 'down',
  },
];

const getRankColor = (rank: number) => {
  if (rank === 1) return 'bg-primary-500 text-background-50';
  if (rank === 2) return 'bg-primary-400 text-background-50';
  if (rank === 3) return 'bg-accent-500 text-background-50';
  return 'bg-background-200 text-foreground-500';
};

const getTrendIcon = (trend: string) => {
  if (trend === 'up') return <i className="ri-arrow-up-line text-green-500 text-xs"></i>;
  if (trend === 'down') return <i className="ri-arrow-down-line text-red-400 text-xs"></i>;
  return <span className="text-xs text-accent-500 font-medium">NEW</span>;
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10 md:mb-14">
          <div>
            <span className="inline-block text-xs font-medium text-primary-600 bg-primary-50 px-3 py-1 rounded-full mb-3">
              TOP 5
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
              热度榜单
            </h2>
          </div>
          <span className="text-xs text-foreground-400">数据实时更新</span>
        </div>

        <div className="bg-background-50 rounded-xl border border-background-200/60 overflow-hidden">
          {rankings.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-3 md:gap-4 px-4 md:px-6 py-4 cursor-pointer hover:bg-background-100 transition-colors ${
                i < rankings.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <span
                className={`w-7 h-7 md:w-8 md:h-8 rounded-lg flex items-center justify-center text-sm font-bold shrink-0 ${getRankColor(
                  item.rank
                )}`}
              >
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 truncate">{item.title}</h3>
                <span className="text-xs text-foreground-400">{item.tag}</span>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-600 whitespace-nowrap">{item.heat}</span>
              <span className="flex items-center shrink-0">{getTrendIcon(item.trend)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}